<div class="modal-content">
    <div class="modal-body pt-4">
        <form class="needs-validation" novalidate id="formPermiso" [formGroup]="formPermiso">
            <input type="hidden" formControlName="idSprElementoNivelPermiso" [value]="idSprElementoNivelPermiso">
            <div id="accordion" class="mb-3">
                <div class="card mb-1">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group row mb-3">
                                <div class="col col-md-3 text-md-right">
                                    <label for="idSprNivelSelect"
                                        class=" form-control-label text-md-right pt-1 "><b>Nivel:</b></label>
                                </div>
                                <div class="col-12 col-md-9">
                                    <select class="form-select col-12" id="idSprNivelSelect"
                                        formControlName="idSprNivelSelect" (change)="changeNivel($event)">
                                        <option *ngFor="let row of dataNiveles" value={{row.idSprComun}}>
                                            [{{row.nombre}}] - {{row.descripcion}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-group row mb-3">
                                <div class="col col-md-3 text-md-right">
                                    <label for="idSprNivel"
                                        class=" form-control-label text-md-right pt-1 "><b>Ambientes:</b></label>
                                </div>
                                <div class="col-12 col-md-9">
                                    <select class="form-select col-12" id="idSprAmbiente"
                                        formControlName="idSprAmbiente" (change)="changeSelectedAmbiente($event)">
                                        <option *ngFor="let tipo of dataAmbientesNiveles" value={{tipo.idSprAmbiente}}*{{tipo.nombreUnidad}}*{{tipo.nombreCorto}}*{{tipo.idSprNivel}}*{{tipo.nivel.nombre}}>
                                            [{{tipo.nombreCorto}}] - {{tipo.nombreUnidad}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-info" (click)="buscarElemento()">Buscar</button>
    </div>
</div>


<!--
    <div *ngIf="nombreElemento == 'Atribuciones'">
        <app-atribucion [inputAmbiente]="idSprAmbiente"></app-atribucion>
    </div>
    <div *ngIf="nombreElemento == 'Objetivos'">
        <app-objetivos></app-objetivos>
    </div>
    <div *ngIf="nombreElemento == 'LineasAccion'"></div>
    <div *ngIf="nombreElemento == 'Proyectos'"></div>

    <jw-modal id="{{nameModalBuscar}}">
        <div class="modal-dialog" style="padding-top:8%">
            <div class="modal-content">
                <div class="modal-header pb-3">
                    <h3 class="modal-title">{{nameApp}}</h3>
                    <button type="button" class="btn-close" (click)="closeModal();" aria-label="Close"></button>
                </div>
                <div class="modal-body pt-4">
                    <form class="needs-validation" novalidate id="formPermiso" [formGroup]="formPermiso">
                        <input type="hidden" formControlName="idSprElementoNivelPermiso"
                            [value]="idSprElementoNivelPermiso">
                        <div id="accordion" class="mb-3">
                            <div class="card mb-1">
                                <div class="card-body">
                                    <div class="row">

                                        <div class="form-group row mb-3">
                                            <div class="col col-md-3 text-md-right">
                                                <label for="idSprNivelSelect"
                                                    class=" form-control-label text-md-right pt-1 "><b>Nivel:</b></label>
                                            </div>
                                            <div class="col-12 col-md-9">
                                                <select class="form-select col-12" id="idSprNivelSelect"
                                                    formControlName="idSprNivelSelect" (change)="changeNivel($event)">
                                                    <option *ngFor="let row of dataNiveles" value={{row.idSprComun}}>
                                                        [{{row.nombre}}] - {{row.descripcion}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col col-md-3 text-md-right">
                                                <label for="idSprNivel"
                                                    class=" form-control-label text-md-right pt-1 "><b>Ambientes:</b></label>
                                            </div>
                                            <div class="col-12 col-md-9">
                                                <select class="form-select col-12" id="idSprAmbiente"
                                                    formControlName="idSprAmbiente"
                                                    (change)="changeSelectedAmbiente($event)">
                                                    <option *ngFor="let tipo of dataAmbientesNiveles"
                                                        value={{tipo.idSprAmbiente}}>
                                                        [{{tipo.nombreCorto}}] - {{tipo.nombreUnidad}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">
                                            <div class="col col-md-3 text-md-right">
                                                <label for="idSprNivel"
                                                    class=" form-control-label text-md-right pt-1 "><b>ELementos:</b></label>
                                            </div>
                                            <div class="col-12 col-md-9">
                                                <select class="form-select col-12" id="idSprAplicacion"
                                                    (change)="changeElementos($event)"
                                                    formControlName="idSprAplicacion">
                                                    <option *ngFor="let tipo of elementosIdicadores"
                                                        value={{tipo.value}}>
                                                        {{tipo.label}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group row mb-3">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary waves-effect" (click)="closeModal();">Cerrar</button>
                    <button type="button" class="btn btn-info" (click)="buscarElemento()">Buscar</button>
                </div>
            </div>
        </div>
    </jw-modal>-->